import {createEvent, type Emitter, type Listener} from "react-event-hook";

export interface KhanmigoHasAssignmentRecommendationsPayload {
    /**
     * A key associated with a notification for this event. Used to prevent
     * the notification from appearing until a certain amount of time passes.
     */
    dismissKey: string;
}

interface Event {
    /**
     * Listen for the khanmigo-has-assignment-recommendations event.
     */
    useKhanmigoHasAssignmentRecommendationsListener: Listener<KhanmigoHasAssignmentRecommendationsPayload>;
    /**
     * Emit the khanmigo-has-assignment-recommendations event.
     */
    emitKhanmigoHasAssignmentRecommendations: Emitter<KhanmigoHasAssignmentRecommendationsPayload>;
}

export const {
    useKhanmigoHasAssignmentRecommendationsListener,
    emitKhanmigoHasAssignmentRecommendations,
} = createEvent("khanmigo-has-assignment-recommendations")() as Event;
